import React, { Fragment, useEffect, useState } from 'react'
import { TextField, MenuItem, Box, Chip } from '@mui/material'
import { useWarehouses } from '../../../hooks'
import { Warehouse } from '../../../interfaces'

interface WarehouseDDLProps {
  type?: 'outlined' | 'filled' | 'standard' | undefined
  fullWidth?: boolean
  name?: string
  valueKey?: 'id' | 'warehouseName'
  required?: boolean
  withoutThisPositions?: number[]
  warehousesIds: number[]
  setWarehousesIds: any
  label?: string
}

export const WarehouseMultiselectDLL: React.FC<WarehouseDDLProps> = ({
  type,
  fullWidth = false,
  name = 'warehouseId',
  valueKey = 'id',
  required = false,
  warehousesIds = [],
  setWarehousesIds,
  label
}) => {
  const [hasError, setHasError] = useState<boolean>(false)
  const [wareHouseSelected, setWareHouseSelected] = useState<number>(-1)

  const {
    warehousesState: { warehouses },
    getWarehouses
  } = useWarehouses()

  useEffect(() => {
    if (warehouses?.length === 0) {
      getWarehouses()
    }
  }, [])

  useEffect(() => {
    // Validar si es obligatorio y si se ha seleccionado alguna opción
    if (required && wareHouseSelected === -1) {
      setHasError(true)
    } else {
      setHasError(false)
    }
  }, [wareHouseSelected, required])

  const arrTypePositions =
    warehouses !== undefined
      ? warehouses
          .filter((item) => !warehousesIds.includes(item.id))
          .map((option: Warehouse) => (
            <MenuItem key={option[valueKey]} value={option[valueKey]}>
              {option.warehouseName}
            </MenuItem>
          ))
      : []

  const deleteWarehouseSelected = (elementoAEliminar: number) => {
    setWarehousesIds((prevState: any) =>
      prevState.filter((el: any) => el !== elementoAEliminar)
    )
  }

  // Agrega state de selección para DLL y agrega selección al array
  const handleInputChange = ({ target }: any) => {
    setWareHouseSelected(-1)
    if (target.value > 0) {
      setWarehousesIds([...warehousesIds, target.value])
    }
  }

  return (
    <Fragment>
      <TextField
        variant={type}
        id='warehouseId'
        name={name}
        select
        value={wareHouseSelected}
        onChange={handleInputChange}
        fullWidth={fullWidth}
        error={hasError}
        helperText={hasError ? 'Seleccionar Almacén' : undefined}
        label={label}
      >
        <MenuItem key={-1} value={-1}>
          {'Seleccionar Almacén...'}
        </MenuItem>
        {arrTypePositions}
      </TextField>
      <Box
        style={{
          marginTop: '0.5%',
          display: 'flex',
          flexWrap: 'wrap',
          gap: '0.5'
        }}
      >
        {warehouses?.map(
          (e) =>
            warehousesIds.find((wid) => wid === e.id) && (
              <Chip
                key={e.id}
                label={e.warehouseName}
                onDelete={() => deleteWarehouseSelected(e.id)}
              />
            )
        )}
      </Box>
    </Fragment>
  )
}
